import ButtonSimple from './buttons/ButtonSimple';
import ButtonWithVO from './buttons/ButtonWithVO';
import { PLAYER_SINGLE, PLAYER_TWO } from '../constants/AppConstants';

export default class OverlayPlayerMode extends Phaser.Group {
  constructor(game, animateBg) {
    super(game);

    //
    this.createContent();

    // animations
    if (animateBg) {
      this.bg.alpha = 0;
      this.game.add.tween(this.bg).to({ alpha: 1 }, 300, Phaser.Easing.Quadratic.Out, true);
    }
    this.btnPlayer1.scale.set(0);
    this.game.add
      .tween(this.btnPlayer1.scale)
      .to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true);
    this.btnPlayer2.scale.set(0);
    this.game.add
      .tween(this.btnPlayer2.scale)
      .to({ x: 1, y: 1 }, 300, Phaser.Easing.Back.Out, true, 100);

    //
    this.onSelect = new Phaser.Signal();
    this.onBack = new Phaser.Signal();

    //
    this.game.scale.onSizeChange.add(this.positionElements, this);
  }

  createContent() {
    // blurred background
    this.bg = this.game.make.image(0, 0, 'bg_welcome_blur');

    //
    this.text = this.game.make.text(this.game.defaultWidth / 2, 110, 'How many players?', {
      font: '70px Elinor',
      fill: '#FFFFFF',
      stroke: '#000000',
      strokeThickness: 8,
    });
    this.text.anchor.set(0.5, 0);

    // button 1 player
    this.btnPlayer1 = new ButtonWithVO({
      game: this.game,
      bg: 'btn_player_bg',
      mask: 'btn_player_mask',
      key: 'btn_one_player',
      dy: -5,
      voId: 'ui_01_elinor_010',
    });
    this.btnPlayer1.x = this.game.defaultWidth / 2 - 140;
    this.btnPlayer1.y = 385;
    this.btnPlayer1.onInputDown.addOnce(this.handlePlayerSelect, this);

    // button 2 players
    this.btnPlayer2 = new ButtonWithVO({
      game: this.game,
      bg: 'btn_player_bg',
      mask: 'btn_player_mask',
      key: 'btn_two_players',
      dy: -5,
      voId: 'ui_01_elinor_011',
    });
    this.btnPlayer2.x = this.game.defaultWidth / 2 + 140;
    this.btnPlayer2.y = 385;
    this.btnPlayer2.onInputDown.addOnce(this.handlePlayerSelect, this);

    // back button
    this.btnBack = new ButtonSimple({ game: this.game, up: 'btn_back', over: 'btn_back' });
    this.btnBack.x = (this.game.defaultWidth - this.game.width) * 0.5 + 60;
    this.btnBack.y = 60;
    this.btnBack.onInputDown.addOnce(this.handleBackBtn, this);

    //
    this.addChild(this.bg);
    this.addChild(this.text);
    this.addChild(this.btnPlayer1);
    this.addChild(this.btnPlayer2);
    this.addChild(this.btnBack);
  }

  positionElements() {
    this.btnBack.x = (this.game.defaultWidth - this.game.width) * 0.5 + 60;
  }

  handlePlayerSelect(btn) {
    this.selectedButton = btn;
    // lock all buttons
    this.btnPlayer1.inputEnabled = false;
    this.btnPlayer2.inputEnabled = false;
    this.btnBack.inputEnabled = false;

    // zoom the button
    // btn.scale.set(1);
    // this.game.add.tween(btn.scale).to({ x: 1.1, y: 1.1 }, 300, Phaser.Easing.Back.Out, true);

    // wait 1 second
    this.game.time.events.add(1000, this.dispatchEvent, this);
  }

  dispatchEvent() {
    if (this.selectedButton === this.btnPlayer1) {
      this.onSelect.dispatch(PLAYER_SINGLE);
    } else {
      this.onSelect.dispatch(PLAYER_TWO);
    }
  }

  handleBackBtn() {
    this.onBack.dispatch();
  }

  destroy() {
    this.game.scale.onSizeChange.remove(this.positionElements, this);

    this.btnPlayer1.destroy();
    this.btnPlayer2.destroy();
    this.btnBack.destroy();
    this.btnPlayer1 = null;
    this.btnPlayer2 = null;
    this.btnBack = null;
    this.text = null;
    this.bg = null;
    super.destroy();
  }
}
